import { createReducer, on } from '@ngrx/store'
import {
   retriveProjectFinalProposals,
   retriveProjectFinalProposalsFailure,
   retriveProjectFinalProposalsSuccess,
} from '../feature-project-detail/feature-pd.actions'
import * as FeatureSPActions from './feature-sp.actions'
import { FeatureSPState } from './feature-sp.state'

export const initialState: FeatureSPState = {
   isSearchOpen: true,
   searchResult: undefined,
   isLoading: false,
   isSearchDone: false,
   searchRequest: undefined,
   isAdvancedSearch: false,
}

export const featureSPReducer = createReducer(
   initialState,
   on(FeatureSPActions.openSPSearch, (state) => ({ ...state, isSearchOpen: true })),
   on(FeatureSPActions.closeSPSearch, (state) => ({ ...state, isSearchOpen: false })),
   on(FeatureSPActions.setIsAdvancedSPSearch, (state, action) => ({ ...state, isAdvancedSearch: action.isAdvanced })),
   on(FeatureSPActions.setFalseIsAdvancedSPSearch, (state) => ({ ...state, isAdvancedSearch: false })),
   on(FeatureSPActions.search, (state) => ({ ...state, searchResult: undefined, isLoading: true, isSearchDone: true })),
   on(FeatureSPActions.searchSuccess, (state, action) => ({ ...state, searchResult: action.result, isSearchOpen: false })),
   on(FeatureSPActions.searchSuccess, FeatureSPActions.searchFailure, (state) => ({ ...state, isLoading: false })),

   on(FeatureSPActions.setActualOrder, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, field: action.order } },
   })),
   on(FeatureSPActions.setActualPage, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, pageNumber: action.page } },
   })),
   on(FeatureSPActions.setSearchRequest, (state, action) => ({
      ...state,
      searchRequest: action.request,
   })),
   on(FeatureSPActions.setItemForPage, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, pageSize: action.itemForPage } },
   })),
   on(FeatureSPActions.initSearch, (state) => ({
      ...state,
      isSearchOpen: true,
      searchResult: undefined,
      isLoading: false,
      isSearchDone: false,
      searchRequest: undefined,
   })),
   on(retriveProjectFinalProposals, (state, action) => ({
      ...state,
      searchResult: {
         ...state.searchResult,
         results: [
            ...(state.searchResult?.results?.map((item) => {
               let newItem = { ...item }
               if (item.id == action.id) {
                  newItem.isLoadingFinalProposals = true
               }
               return newItem
            }) ?? []),
         ],
      },
   })),
   on(retriveProjectFinalProposalsSuccess, retriveProjectFinalProposalsFailure, (state, action) => ({
      ...state,
      searchResult: {
         ...state.searchResult,
         results: [
            ...(state.searchResult?.results?.map((item) => {
               let newItem = { ...item }
               if (item.isLoadingFinalProposals) {
                  newItem.isLoadingFinalProposals = false
               }
               return newItem
            }) ?? []),
         ],
      },
   })),
   on(FeatureSPActions.exportExcelResults, (state) => ({
      ...state,
      isDownloadLoading: true,
   })),
   on(FeatureSPActions.exportExcelResultsSuccess, FeatureSPActions.exportExcelResultsFailure, (state) => ({
      ...state,
      isDownloadLoading: false,
   }))
)
